import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
//import SinglePicsPage from '../components/SinglePics'
import ProjectPage from '../components/ProjectPage'

const projectElements = {
	images: [
		{
		"src": "Portraits/vali_6",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_10",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_11",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_12",
		"orientation": "landscape"
		},
		{
		"src": "Portraits/vali_8",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_9",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_7",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/julia_3" ,
		"orientation": "landscape"
		},
		{
		"src": "Portraits/julia_1",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/julia_2",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/julia_5",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/julia_4",
		"orientation": "landscape"
		},
		{
		"src": "Portraits/lena_3",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/lena_1",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/lena_4",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/lena_2",
		"orientation": "landscape"
		},
		{
		"src": "Portraits/vali_3",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_4",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_1",
		"orientation": "portrait"
		},
		{
		"src": "Portraits/vali_5",
		"orientation": "landscape"
		}
]
}

export default class PortraitPage extends React.Component {
	render(){
		return(
			<ProjectPage 
			title="Portraits" 
			text="" 
			images={projectElements.images}
			layout={'singlesImages'}/>
		) 
	}
}



// WEBPACK FOOTER //
// ./src/pages/portrait.js